import React, { useState } from "react"
import KosmoButton from "@/UI/Buttons/KosmoButton"
import { useTranslation } from "react-i18next"
import { message } from "antd"
import { faArrowRotateRight } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Stop } from "@/types/stops.types"
import { useDraftOrders } from "@/hooks/useDraftOrders"
import DuplicateStopsModal from "@/UI/Modals/DuplicateStopsModal/DuplicateStopsModal"

interface BulkStopsReorderProps {
  stops: Stop[]
  withRedirect?: boolean
}

const BulkStopsReorder: React.FC<BulkStopsReorderProps> = ({ stops }) => {
  const { t } = useTranslation()
  const { createDraftOrdersFromOrder, isCreatingDraftOrder: isLoading } = useDraftOrders()
  const [existingIDs, setExistingIDs] = useState<string[]>([])

  const handleBatchReorder = async (duplicateMode?: string) => {
    const payload = stops.map((stop) => ({ ...stop, recipients: [stop?.recipient] }))
    try {
      await createDraftOrdersFromOrder(payload, duplicateMode)
      message.success(t("active-orders.OrderAgainButton.successfullyBatchCreatedPlannedStops"))
    } catch (error: any) {
      const duplicatedKeys = error.response?.data?.existing_ids
      if (duplicatedKeys?.length > 0) {
        setExistingIDs(error.response?.data?.existing_ids)
      }
    }
  }

  return (
    <>
      <DuplicateStopsModal
        existingIds={existingIDs}
        setExistingIds={setExistingIDs}
        handleReorderAsPlanned={handleBatchReorder}
        isLoading={isLoading}
      />
      <KosmoButton
        onClick={() => handleBatchReorder()}
        size="middle"
        classname=""
        isLoading={isLoading}
        isDisabled={isLoading}
        type="default"
      >
        <div className="flex items-center space-x-2">
          <FontAwesomeIcon icon={faArrowRotateRight} />
          <p>
            {stops?.length > 1
              ? t("active-orders.duplicateStops")
              : t("active-orders.duplicateStop")}
          </p>
        </div>
      </KosmoButton>
    </>
  )
}

export default BulkStopsReorder
